import { AxiosResponse } from 'axios';
import { unprocessableEntity_422 } from 'services/api/api.statusCodes';
import { ApiErrorInfos, ApiResponseErrorPayload } from 'services/api/api.types';
import { formErrorKey, genericErrorId } from 'services/forms/forms.config';

export default function mapValidationErrors(
  errorResponse: AxiosResponse<ApiResponseErrorPayload>,
  errorMap: Record<string, string>,
): Record<string, string> | undefined {
  const { status, data } = errorResponse;

  if (status === unprocessableEntity_422 && data?.error?.errorInfos) {
    const errorInfos = data.error.errorInfos as ApiErrorInfos;
    const output = {} as Record<string, string>;

    const entries = Object.entries(errorInfos);

    for (let i = 0, len = entries.length; i < len; i++) {
      const [errorKey, validationErrors] = entries[i];

      if (errorKey === 'generic') {
        const errorNameKey = errorMap[errorKey] || formErrorKey;

        output[errorNameKey] = validationErrors[0] || genericErrorId;
      } else if (typeof errorMap[errorKey] === 'string') {
        output[errorMap[errorKey]] = validationErrors[0];
      }
    }

    return output;
  }

  return undefined;
}
